class SectionTestimonials extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.onClick = this.onClick.bind(this)

    this.els?.button?.elements.forEach(buttonEl => {
      this.listeners.add(buttonEl, 'click', this.onClick)
    })
  }

  onClick (event) {
    const currentButtonEl = event.target.closest(this.els?.button?.selector)

    this.els?.content?.elements.forEach(contentEl => {
      contentEl.setAttribute(
        'aria-current',
        currentButtonEl.dataset.index === contentEl.dataset.index,
      )
    })

    this.els?.button?.elements.forEach(buttonEl => {
      buttonEl.setAttribute(
        'aria-current',
        currentButtonEl.dataset.index === buttonEl.dataset.index,
      )
    })
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new window.KeenSlider(
      this.els?.slides?.element,
      {
        selector: this.els?.slide?.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          origin: 'center',
          perView: 1.75,
          spacing: 0,
        },
        created: this.onSlideChanged,
        slideChanged: this.onSlideChanged,
      },
      [window.BAO.carousel.useInitialised()],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els?.slide?.elements.forEach((slide, index) => {
      slide.setAttribute('aria-current', index === currentSlide)
    })

    this.els?.content?.elements.forEach(content => {
      content.setAttribute(
        'aria-current',
        parseInt(content.dataset.index) === currentSlide,
      )
    })
  }
}

if (!customElements.get('section-testimonials')) {
  customElements.define('section-testimonials', SectionTestimonials)
}
